import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/card-saga/actions';
import { ResponseTransformer } from '../ResponseTransformer';

export const actionCardApi = {
    getAll: async () => {
        const { data } = await http.get(`${API_PREFIX}`);
        return data;
    },

    create: async () => {
        const { data } = await http.get(`${API_PREFIX}/create`);

        const card = new ResponseTransformer(data);
        card.transformObjectKey();

        return card;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);

        const card = new ResponseTransformer(data);
        card.transformObjectKey();
        card.transformKeyword();

        return card;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};
